// AuthFromUrl.js - Utility to handle authentication from URL parameters

let authCheckInterval = null;
let lastCheckedUrl = '';

const processAuthParams = (urlString) => {
  try {
    console.log('========================================');
    console.log('🔍 Processing URL for auth params...');
    console.log('URL:', urlString);
    
    // Parse URL to get search params
    let urlParams;
    try {
      const url = new URL(urlString);
      urlParams = new URLSearchParams(url.search);
      console.log('Search params:', url.search);
    } catch (e) {
      // Fallback to window.location if URL parsing fails
      urlParams = new URLSearchParams(window.location.search);
      console.log('Search params (fallback):', window.location.search);
    }
    
    // Log all parameters
    const allParams = {};
    urlParams.forEach((value, key) => {
      allParams[key] = value.substring(0, 50) + (value.length > 50 ? '...' : '');
    });
    console.log('All URL parameters:', allParams);
    
    const appUser = urlParams.get('appUser');
    const appToken = urlParams.get('appToken');
    const appUserType = urlParams.get('appUserType');
    
    console.log('Auth params found:', { 
      appUser: appUser ? `Yes (${appUser.length} chars)` : 'No',
      appToken: appToken ? `Yes (${appToken.length} chars)` : 'No', 
      appUserType: appUserType ? `Yes (${appUserType.length} chars)` : 'No' 
    });
    
    if (appUser && appToken && appUserType) {
      console.log('✅ Found auth params in URL, processing...');
      
      // Decode URI components and parse JSON
      const user = JSON.parse(decodeURIComponent(appUser));
      const token = JSON.parse(decodeURIComponent(appToken));
      const userType = JSON.parse(decodeURIComponent(appUserType));
      
      console.log('Decoded user:', user);
      console.log('Decoded token:', token);
      console.log('Decoded userType:', userType);
      
      // Store to localStorage (stringify for localStorage)
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', JSON.stringify(token));
      localStorage.setItem('userType', JSON.stringify(userType));
      
      console.log('✅ Authentication data set to localStorage successfully');
      console.log('User type:', userType);
      console.log('User name:', user?.name || user?.Name);
      
      // Clean up URL (remove auth parameters)
      urlParams.delete('appUser');
      urlParams.delete('appToken');
      urlParams.delete('appUserType');
      
      const newUrl = window.location.pathname + 
        (urlParams.toString() ? '?' + urlParams.toString() : '') + 
        window.location.hash;
      
      console.log('🧹 URL cleaned:', newUrl);
      
      // Use replaceState to update URL without reloading
      window.history.replaceState({}, '', newUrl);
      console.log('========================================');
      
      // Stop the interval once auth is successful
      if (authCheckInterval) {
        clearInterval(authCheckInterval);
        authCheckInterval = null;
      }
      
      return true; // Authentication was successful
    } else {
      console.log('❌ No auth params found in URL');
      console.log('========================================');
      return false;
    }
  } catch (error) {
    console.error('❌ Error processing auth params from URL:', error);
    console.log('========================================');
    return false;
  }
};

export const handleAuthFromUrl = () => {
  return processAuthParams(window.location.href);
};

// Start listening for URL changes (catches all navigation)
export const startAuthUrlListener = (onAuthSuccess) => {
  console.log('🎧 Starting auth URL listener...');
  
  // Check immediately on start
  const initialAuth = processAuthParams(window.location.href);
  if (initialAuth && onAuthSuccess) {
    onAuthSuccess();
  }
  
  // Set up interval to check for URL changes
  authCheckInterval = setInterval(() => {
    const currentUrl = window.location.href;
    
    // Only process if URL has changed
    if (currentUrl !== lastCheckedUrl) {
      console.log('🔄 URL changed, checking for auth params...');
      lastCheckedUrl = currentUrl;
      
      const authenticated = processAuthParams(currentUrl);
      if (authenticated && onAuthSuccess) {
        onAuthSuccess();
      }
    }
  }, 100); // Check every 100ms
  
  // Also listen to popstate and hashchange events
  const handleUrlChange = () => {
    console.log('📍 URL change event detected');
    const authenticated = processAuthParams(window.location.href);
    if (authenticated && onAuthSuccess) {
      onAuthSuccess();
    }
  };
  
  window.addEventListener('popstate', handleUrlChange);
  window.addEventListener('hashchange', handleUrlChange);
  
  return () => {
    // Cleanup function
    if (authCheckInterval) {
      clearInterval(authCheckInterval);
      authCheckInterval = null;
    }
    window.removeEventListener('popstate', handleUrlChange);
    window.removeEventListener('hashchange', handleUrlChange);
  };
};

// Stop the listener
export const stopAuthUrlListener = () => {
  if (authCheckInterval) {
    clearInterval(authCheckInterval);
    authCheckInterval = null;
    console.log('🛑 Auth URL listener stopped');
  }
};

